<script lang="ts" setup>
    import { useDisplay, useTheme } from 'vuetify';
    import { Theme } from '@/constants';
    import { useAppStore } from '@/stores/app';

    const theme = useTheme();
    const display = useDisplay();
    const { t } = useI18n();
    const appStore = useAppStore();

    const darkMode = (): void => {
        appStore.currentTheme = theme.global.name.value === Theme.Light ? Theme.Dark : Theme.Light;
        localStorage.setItem('isDark', String(appStore.currentTheme === Theme.Dark));
    };

    onMounted((): void => {
        console.log('Component app-menu-dark-switcher was created.');
    });
</script>
<template>
    <span>
        <v-btn
            :data-tooltip="theme.name.value !== Theme.Dark ? t('dark.off') : t('dark.on')"
            tag="a"
            class="link-menu"
            :height="display.xs.value ? 30 : 46"
            min-width="30"
            :width="display.xs.value ? 30 : 50"
            variant="text"
            @click="darkMode"
            style="font-size: 15px"
        >
            <v-icon v-if="theme.name.value !== Theme.Dark" color="#867878" :icon="mdiWeatherNight" />
            <v-icon v-else class="theme-switcher__sun" :icon="mdiWhiteBalanceSunny" />
        </v-btn>
    </span>
</template>
<style lang="scss" scoped>
    .theme-switcher__sun {
        color: #ffeb3b !important;
    }
</style>
